const RoomCalendarCard = ({ data }) => {
  // console.log(data);
  return (
    <tr className="class-table" style={{ position: "relative" }}>
      <td
        style={{
          position: "sticky",
          left: 0,
          backgroundColor: "white",
          zIndex: 1,
          outline: "1px solid gray",
          outlineOffset: "-1px",
          borderWidth: 0,
        }}
      >
        <div className="td-con">
          <div
            className="table-scroll-text"
            style={{
              color:
                data.day === "Saturday" || data.day === "Sunday"
                  ? "#5d2ef6ff"
                  : "",
            }}
          >
            {data.date}
          </div>
        </div>
      </td>
      <td
        style={{
          position: "sticky",
          left: 150,
          backgroundColor: "white",
          zIndex: 1,
          outline: "1px solid gray",
          outlineOffset: "-1px",
        }}
      >
        <div className="td-con">
          <div
            className="table-scroll-text"
            style={{
              color:
                data.day === "Saturday" || data.day === "Sunday"
                  ? "#5d2ef6ff"
                  : "",
            }}
          >
            {data.day}
          </div>
        </div>
      </td>
      {data?.rooms?.map((room) => (
        <td key={room._id} style={{ padding: "0", width: "300px" }}>
          <div
            style={{
              display: "table",
              width: "100%",
              height: "100%",
              tableLayout: "fixed",
            }}
          >
            <div style={{ display: "table-row" }}>
              <div
                style={{
                  display: "table-cell",
                  width: "33.333%",
                  padding: " 12px",
                  textAlign: "center",
                  borderRight: "1px solid #ddd",
                  color:
                    room.hours[0].status === "waiting"
                      ? "red"
                      : data.day === "Saturday" || data.day === "Sunday"
                      ? "#5d2ef6ff"
                      : "",
                }}
              >
                {room.hours[0]["10:00"]}
              </div>
              <div
                style={{
                  display: "table-cell",
                  width: "33.333%",
                  padding: " 12px",
                  textAlign: "center",
                  borderRight: "1px solid #ddd",
                  color:
                    room.hours[1].status === "waiting"
                      ? "red"
                      : data.day === "Saturday" || data.day === "Sunday"
                      ? "#5d2ef6ff"
                      : "",
                }}
              >
                {room.hours[1]["15:00"]}
              </div>
              <div
                style={{
                  display: "table-cell",
                  width: "33.333%",
                  padding: " 12px",
                  textAlign: "center",
                  borderRight: "1px solid #ddd",
                  color:
                    room.hours[2].status === "waiting"
                      ? "red"
                      : data.day === "Saturday" || data.day === "Sunday"
                      ? "#5d2ef6ff"
                      : "",
                }}
              >
                {room.hours[2]["19:00"]}
              </div>
            </div>
          </div>
        </td>
      ))}
      <td></td>
    </tr>
  );
};

export default RoomCalendarCard;
